// Used in assignment-info-dialog.component.html and tiles.component.html

// Angular
import { Component, Input, OnInit } from "@angular/core";

@Component({
    selector: "cog-tutor-directions",
    templateUrl: "./cog-tutor-directions.component.html",
    styleUrls: [
        "./cog-tutor-directions.component.scss",
        "../../../styles/shared-styles.scss",
    ],
    standalone: false
})
export class CogTutorDirectionsComponent implements OnInit {
    @Input() directions: string;
    @Input() fontSize: string;

    constructor() {}

    ngOnInit(): void {}
}
